<template id="map-template">
  <div class="zj-homeview-root select-none">
    <div class="nav-section">
      <div class="content-wrapper">
        <NavViewFastTrackEntrance></NavViewFastTrackEntrance>
      </div>
      <div class="content-wrapper">
        <NavViewMessageCenter></NavViewMessageCenter>
      </div>
    </div>
  </div>
</template>

<script>
import NavViewFastTrackEntrance from "./components/NavViewFastTrackEntrance";
import NavViewMessageCenter from "./components/NavViewMessageCenter";

export default {
  name: "HomeView",
  componentName: "HomeView",
  components: {
    NavViewFastTrackEntrance,
    NavViewMessageCenter
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {};
  },
  methods: {},
  created() {
    // eslint-disable-next-line no-undef
    //$(".zj-app").addClass("zj-fullscreen-mapview");
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {
    // eslint-disable-next-line no-undef
    //$(".zj-app").removeClass("zj-fullscreen-mapview");
  },
  controller: "UI",
  action: "NavView",
};
</script>

<style scoped>
.nav-section {
  position: relative;
  height: 100%;
  width: 100%;
  padding: 30px;
}

.nav-section .content-wrapper:nth-child(1){
  float:left;
  width: 60%;
  height: 100%;
}


.nav-section .content-wrapper:nth-child(2){
  float:left;
  width: 40%;
  height: 100%;
}

.table-chart{
  height: 100%;
  width: 100%;
}
</style>